import React from 'react';
import './radioButton.scss';
import Button from '../button/Button';

export type RadioButtonType = {
    label: string;
    onClick?: () => void;
    description?: string;
    active?: boolean;
    trailing?: JSX.Element;
    size?: 'sm' | 'md' | 'lg';
    enableHover?: boolean;
    dataCy?: string;
    fullWidth?: boolean;
};

function RadioButton({
    label,
    description,
    onClick,
    active,
    trailing,
    size = 'lg',
    enableHover,
    dataCy,
    fullWidth = false,
}: RadioButtonType): JSX.Element {
    return (
        <Button
            onClick={onClick}
            type="button"
            color="frost"
            variant="ghost"
            leading={active ? 'solar:check-square-bold' : 'solar:stop-linear'}
            align="left"
            fullWidth={fullWidth}
            size={size}
            data-cy={dataCy}
            disableHover={!enableHover}
        >
            <div className="c-radioButton">
                <div className="c-radioButton__content">
                    <div className="c-radioButton__content_title">{label}</div>
                    <div className="c-radioButton__content_subtitle">{description}</div>
                </div>
                {trailing}
            </div>
        </Button>
    );
}

export default RadioButton;
